/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * When a document needs to be encrypted, the responsible generates a cryptographically random master key (different from the delegation key, never to appear in clear anywhere in the db. He/she encrypts it using his own AES exchange key and stores it as a delegation
 */
export class Delegation {
  constructor(json: JSON | any) {
    Object.assign(this as Delegation, json)
  }

  owner?: string
  delegatedTo?: string
  key?: string
  /**
   * @deprecated replaced by access control
   */
  tags?: Array<string>
}
